import React from "react";
import { Link } from "react-router-dom";

export default function Cancel() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(145deg, #0F0F0F, #1C1C1C)",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "2rem",
        backgroundImage:
          "url('https://www.transparenttextures.com/patterns/cubes.png')",
        backgroundSize: "200px",
      }}
    >
      <h1
        style={{
          fontSize: "2.5rem",
          background: "linear-gradient(90deg, #FF1744, #E91E63)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "1rem",
        }}
      >
        ⚠️ Payment Cancelled
      </h1>

      <p
        style={{
          color: "#BDBDBD",
          maxWidth: "500px",
          lineHeight: "1.6",
        }}
      >
        You cancelled your <strong>ReflectRise Premium</strong> payment.  
        No worries — you can upgrade anytime to unlock premium features.
      </p>

      <Link
        to="/premium"
        style={{
          marginTop: "2rem",
          padding: "12px 30px",
          background: "linear-gradient(135deg, #9C27B0, #E91E63)",
          borderRadius: "10px",
          color: "#fff",
          textDecoration: "none",
          fontWeight: "bold",
          boxShadow: "0 0 10px rgba(233,30,99,0.6)",
          transition: "all 0.3s ease",
        }}
        onMouseOver={(e) =>
          (e.target.style.boxShadow = "0 0 20px rgba(233,30,99,1)")
        }
        onMouseOut={(e) =>
          (e.target.style.boxShadow = "0 0 10px rgba(233,30,99,0.6)")
        }
      >
        Return to Premium Page
      </Link>
    </div>
  );
}
